import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import focusValuesUK from "@/.sourceflow/about_us_focus_values.json";
import focusValuesUS from "@/.sourceflow/about_us_focus_values_us.json";

export const useFocusValues = ({ locale, limit } = {}) => {
  const collection = useSourceFlowCollection(locale == "/us/" ? focusValuesUS : focusValuesUK);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useFocusValues;
